module.exports = __webpack_public_path__ + "static/airmason_judy-b775170c26f7e1d62ad3ac94c5e45c03.png";